var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('EmployeesTable',{attrs:{"title":"Employees","employees":_vm.employeeData,"cid":_vm.cid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }